import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex space-x-2 py-4"
};
const _hoisted_2 = {
  class: "w-1/2 space-y-4"
};
const _hoisted_3 = {
  class: "w-1/2"
};
const _hoisted_4 = {
  class: "block-content"
};
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlTextarea from '@/components/LlTextarea.vue';
import { useInvoiceState } from '@/modules/billing/review/editDraft/useInvoiceState';
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import { onMounted, reactive } from 'vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useAccountsStore } from '@/services/UserService/useAccountsStore';
import { storeToRefs } from 'pinia';
export default {
  __name: 'MemoModal',
  emits: ['cancel'],
  setup(__props, {
    emit: __emit
  }) {
    const accountsStore = useAccountsStore();
    const invoiceState = useInvoiceState();
    const {
      terms,
      me
    } = storeToRefs(useMeStore());
    const {
      isSaving,
      onlyViewInvoice
    } = storeToRefs(useInvoiceEditorStore());
    const {
      getIsLocked
    } = storeToRefs(useInvoiceState());
    const memoState = reactive({
      accounts: [],
      memo: {
        note: '',
        memo: '',
        trust: '',
        matters: '',
        accounts: '',
        customFields: '',
        showTrust: false,
        showMatterTotals: false,
        showAccountTotals: false,
        showCustomFields: false
      }
    });
    const {
      isSplitBilling
    } = invoiceState;
    const emit = __emit;
    onMounted(async () => {
      memoState.memo = JSON.parse(JSON.stringify(invoiceState.memo));
      memoState.accounts = await accountsStore.listAccounts();
      updateMemo();
    });
    const showMatterTotals = () => {
      return memoState.memo.showMatterTotals;
    };
    const showCustomFields = () => {
      return memoState.memo.showCustomFields;
    };
    const showAccountTotals = () => {
      return memoState.memo.showAccountTotals;
    };
    const updateMemo = () => {
      memoInit();
      // Initialize memo with the note or an empty string
      memoState.memo.memo = memoState.memo.note || '';

      // Append memo content conditionally
      appendToMemo(memoState.memo.showTrust ? memoState.memo.trust : '');
      appendToMemo(showMatterTotals() ? memoState.memo.matters : '');
      appendToMemo(showAccountTotals() ? memoState.memo.accounts : '');
      appendToMemo(showCustomFields() ? memoState.memo.customFields : '');
    };

    // Helper function to append content with line breaks
    const appendToMemo = content => {
      if (content) {
        if (memoState.memo.memo) {
          memoState.memo.memo += '\n\n';
        }
        memoState.memo.memo += content;
      }
    };
    const memoInit = () => {
      // Initialize memo sections
      memoState.memo.trust = '';
      memoState.memo.matters = '';
      memoState.memo.accounts = '';
      memoState.memo.customFields = '';

      // Use already computed values from store if available, otherwise generate using helper functions
      if (memoState.memo.showTrust) {
        memoState.memo.trust = invoiceState.memo?.trust || invoiceState.generateTrustMemo();
      }
      if (memoState.memo.showMatterTotals) {
        memoState.memo.matters = invoiceState.memo?.matters || invoiceState.generateMatterTotalsMemo();
      }
      if (memoState.memo.showCustomFields) {
        memoState.memo.customFields = invoiceState.memo?.customFields || invoiceState.generateCustomFieldsFromGroups();
      }
      if (memoState.memo.showAccountTotals) {
        memoState.memo.accounts = invoiceState.memo?.accounts || invoiceState.generateAccountTotalsMemo();
      }
    };
    const confirm = () => {
      invoiceState.memo = JSON.parse(JSON.stringify(memoState.memo));
      emit('cancel');
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, null, {
        prepend: _withCtx(() => [_createVNode(_component_v_card_title, {
          class: "headline"
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("Invoice Memo", -1)]))]),
          _: 1
        })]),
        append: _withCtx(() => [_createVNode(_component_v_icon, {
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('cancel')),
          "data-cy": "close-memo"
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("mdi-close", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(LlTextarea, {
            label: "Note to add to the invoice",
            modelValue: memoState.memo.note,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => memoState.memo.note = $event),
            variant: "outlined",
            "hide-details": "true",
            labelClass: "text-sm",
            rows: 4,
            onChange: _cache[2] || (_cache[2] = $event => updateMemo()),
            readonly: _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving)
          }, null, 8, ["modelValue", "readonly"])]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(LlCheckbox, {
            "data-cy": "include-custom-fields-checkbox",
            label: "Include Custom Fields",
            modelValue: memoState.memo.showCustomFields,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => memoState.memo.showCustomFields = $event),
            onCheckboxClick: _cache[4] || (_cache[4] = $event => updateMemo()),
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving)
          }, null, 8, ["modelValue", "disabled"]), _createVNode(LlCheckbox, {
            "data-cy": "include-matter-tools-checkbox",
            label: "Include Matter Totals",
            modelValue: memoState.memo.showMatterTotals,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => memoState.memo.showMatterTotals = $event),
            onCheckboxClick: _cache[6] || (_cache[6] = $event => updateMemo()),
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving)
          }, null, 8, ["modelValue", "disabled"]), _createVNode(LlCheckbox, {
            "data-cy": "include-hours-summary-checkbox",
            label: "Include Hours Summary",
            modelValue: memoState.memo.showAccountTotals,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => memoState.memo.showAccountTotals = $event),
            onCheckboxClick: _cache[8] || (_cache[8] = $event => updateMemo()),
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving)
          }, null, 8, ["modelValue", "disabled"])]), _withDirectives(_createElementVNode("div", _hoisted_3, [_createVNode(LlCheckbox, {
            "data-cy": "include-trust-checkbox",
            label: "Include trust balance",
            modelValue: memoState.memo.showTrust,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => memoState.memo.showTrust = $event),
            onCheckboxClick: _cache[10] || (_cache[10] = $event => updateMemo()),
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving)
          }, null, 8, ["modelValue", "disabled"])], 512), [[_vShow, memoState.memo.trust && !_unref(isSplitBilling)]])]), _createElementVNode("div", _hoisted_4, [_createVNode(LlTextarea, {
            "data-cy": "memo-content",
            label: "Final memo contents",
            modelValue: memoState.memo.memo,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => memoState.memo.memo = $event),
            variant: "outlined",
            "hide-details": "true",
            rows: 7,
            labelClass: "text-sm",
            readonly: true
          }, null, 8, ["modelValue"])])]),
          _: 1
        }), _createVNode(_component_v_card_actions, null, {
          default: _withCtx(() => [_createVNode(_component_v_list_item, {
            class: "w-100"
          }, {
            prepend: _withCtx(() => [_createVNode(LlSecondaryButton, {
              "data-cy": "cancel-memo",
              class: "mr-2",
              onBtnClick: _cache[12] || (_cache[12] = $event => _ctx.$emit('cancel')),
              disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving)
            }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode(" Cancel ", -1)]))]),
              _: 1
            }, 8, ["disabled"])]),
            append: _withCtx(() => [_createVNode(LlSecondaryButton, {
              "data-cy": "apply-memo",
              color: "primary",
              variant: "flat",
              onBtnClick: _cache[13] || (_cache[13] = $event => confirm()),
              disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving)
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode(" Apply ", -1)]))]),
              _: 1
            }, 8, ["disabled"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};